



























import {Component, Vue, Prop} from 'vue-property-decorator';
import {Action} from 'vuex-class';

@Component
export default class DlgSubscriptionsDelete extends Vue {
  @Prop({type: Object, default: null}) private subscription!: any;

  private loading: boolean = false;
  private diag: boolean = false;

  @Action('user/subscriptions/del') private subscriptionDel!: any;
  @Action('user/subscriptions/read') private subscriptionRead!: any;

  private del() {
    this.loading = true;

    this.subscriptionDel(this.subscription).then((res) => {
      this.loading = false;
      if (res) {
        this.subscriptionRead();
        this.diag = false;
      }
    });
  }
}
